var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.968,20.804l5.621-5.621c1.479.7,3.299.443,4.523-.781s1.48-3.035.785-4.513l-2.257,2.257c-.527.527-1.382.527-1.909,0s-.527-1.382,0-1.909l2.257-2.257c-1.48-.695-3.297-.435-4.518.79-1.189,1.193-1.446,3.027-.774,4.501l-5.627,5.635c-.523.524-.523,1.373,0,1.897h0c.524.524,1.374.524,1.898,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.072,20.745h5.263c1.685,0,3.242-.899,4.084-2.358l2.335-4.044c.842-1.459.842-3.257,0-4.716l-2.335-4.044c-.842-1.459-2.399-2.358-4.084-2.358h-4.669c-1.685,0-3.242.899-4.084,2.358l-2.335,4.044c-.842,1.459-.842,3.257,0,4.716h0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminTool);
export default __webpack_public_path__ + "static/media/admin-tool.c64803c64199fdb42d334140552f0126.svg";
export { ForwardRef as ReactComponent };